// eslint-disable-next-line import/prefer-default-export
export const FORM = 'barberForm';
export const PROFILE_TAB = 0;
export const SCHEDULE_TAB = 3;
